// define a mixin object
import axios from 'axios'
import Qs from 'qs'

const GlobalHelper = {
  data(){
    return {
      showQuotation:[
        {
          dbName:"pc",
          caption:"Prefered car",
        },
        {
          dbName:"prettyDays",
          caption:"Rental period",
        },
        {
          dbName:"prettyRentalPrice",
          caption:"Rental price",
        },
        {
          dbName:"prettyDebositAmount",
          caption:"Deposit amount",
        },
        {
          dbName:"prettyTransferPrice",
          caption:"Transfer price",
        },
        {
          dbName:"prettyTotalPrice",
          caption:"Total price",
        },
        {
          dbName:"depositName",
          caption:"Deposit type",
        }

      ],
      showData:[
          {
            dbName:"fullName",
            caption:"Full name",
          },
          {
            dbName:"email",
            caption:"Email",
          },
          {
            dbName:"pickupDate",
            caption:"Pickup Date",
            type:"date"
          },
          {
            dbName:"pickupLocation",
            caption:"Pickup Location",
            dbLookupName:"name"
          },

          {
            dbName:"pickupTime",
            caption:"Pickup Time",
          },
          {
            dbName:"dropoffDate",
            caption:"dropoff Date",
            type:"date"
          },
          {
            dbName:"dropoffLocation",
            caption:"Dropoff Location",
            dbLookupName:"name"
          },
          {
            dbName:"dropoffTime",
            caption:"Dropoff Time",
          },

      ],
      stdRules:{
        required: v => !!v || "This field is required",
        email: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
              ],
        notneg: v => parseInt(v) > 0 || "This field is required"
      },
      config:{
        DEPOSIT_TYPE_PERDAY:0,
        DEPOSIT_TYPE_LUMP:1,
        DEPOSIT_FEE_LUMP:500,
        DEPOSIT_FEE_DAILY:12.50,
        TAX_PERCENTAGE:0.09
      },
      userdata:{
        fullName:"",
        email:"",
        pickupDate: '',//new Date().toISOString().substr(0, 10),
        dropoffDate: '',
        pickupTime:"",
        dropoffTime:"",
        pc:"",
        deposit:"",
        pickupLocation:"",
        dropoffLocation:"",
        pickupLocationCustom:"",
        dropoffLocationCustom:"",
        pickupFlightNumber:""
      },
      depositType:[
        "Deposit $500",
        "No deposit ($12.50 extra per day) "
      ],
      carnames:[
        {name:"Metallic",value:35},
        {name:"Iguana",value:35},
        {name:"Solo",value:35},
        {name:"Luna Blou",value:35},
        {name:"Laman",value:35},
        {name:"Rei",value:35},
        {name:"Flamingo",value:35},
        {name:"Blurple",value:35},
        {name:"Nubia",value:55},
        {name:"Any color",value:35}
      ],
      locations:[
   {
       "header": "Jan Thiel Area (25$)"
   },
   {
       "name": "Chogogo Resort ",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "name": "Papagayo Resort ",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "name": "Papagayo Hotel ",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "name": "Livingstone Jan Thiel Resort",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "name": "Morena Resort",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "name": "Bed & Bike Jan Thiel ",
       "price": 25,
       "group": "Jan Thiel Area (25$)"
   },
   {
       "header": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Pietermaai Boutique Hotel",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Boutique hotel 't Klooster",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Scuba Lodge",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Nieuwestraat 4",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Boho Bohemian Boutique Hotel",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Pietermaai PM 78",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "City Suits & Beach Hotel",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Saint Tropez Ocean Club",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Bed & Bike Pietermaai",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "Avila Beach Hotel",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "name": "The Ritz Village (25$)",
       "price": 25,
       "group": "Punda Pietermaai Area (25$)"
   },
   {
       "header": "Mambo Beach Area (25$)"
   },
   {
       "name": "Van Der Valk Kontiki Beach Resort ",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "name": "The Beach House",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "name": "Dolphin Suites",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "name": "Bon Bini Seaside Resort",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "name": "Sunscape Resort",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "name": "Lionsdive Resort ",
       "price": 25,
       "group": "Mambo Beach Area (25$)"
   },
   {
       "header": "Acoya Resort (25$)"
   },
   {
       "name": "Acoya Resort",
       "price": 25,
       "group": "Acoya Resort (25$)"
   },
   {
       "header": "Trupial inn Hotel & Casino"
   },
   {
       "name": "Trupial inn Hotel & Casino (25$)",
       "price": 25,
       "group": "Trupial inn Hotel & Casino"
   },
   {
       "header": "Santa Barbara Beach & Golf Resort"
   },
   {
       "name": "Santa Barbara Beach & Golf Resort (35$)",
       "price": 35,
       "group": "Santa Barbara Beach & Golf Resort"
   },
   {
       "header": "Blue Bay Golf & Beach Resort"
   },
   {
       "name": "Blue Bay Golf & Beach Resort (35$)",
       "price": 35,
       "group": "Blue Bay Golf & Beach Resort"
   },
   {
       "header": "Kunuku Aqua Resort (45$)"
   },
   {
       "name": "Kunuku Aqua Resort",
       "price": 45,
       "group": "Kunuku Aqua Resort (45$)"
   },
   {
       "header": "Corendon Mangrove Beach Resort 35$"
   },
   {
       "name": "Corendon Mangrove Beach Resort",
       "price": 35,
       "group": "Corendon Mangrove Beach Resort 35$"
   },
   {
       "header": "Other(35$)"
   },
   {
       "name": "Please specify",
       "price": 35,
       "group": "Other(35$)"
   }
]
    }
  },
  computed:{
      quotationData(){
        let result = {}
        this.config.RENTAL_DAY_PRICE=this.$store.state.userData.pc.value

        let pickupPrice = this.$store.state.userData.pickupLocation.price
        let dropoffPrice = this.$store.state.userData.dropoffLocation.price

        result['transferPrice'] = (pickupPrice > dropoffPrice? pickupPrice : dropoffPrice)
        result['prettyTransferPrice'] = "$" + result['transferPrice']

        let pu = this.$moment(this.$store.state.userData.pickupDate + " " + this.$store.state.userData.pickupTime)
        let dof = this.$moment(this.$store.state.userData.dropoffDate + " " + this.$store.state.userData.dropoffTime)
        let hours = dof.diff(pu,'hours')

        result['days'] = Math.ceil(hours/24)
        result['pc'] = this.$store.state.userData.pc.name
        result['prettyDays'] = result['days'] + " days x $" + this.config.RENTAL_DAY_PRICE
        result['rentalPrice'] = this.config.RENTAL_DAY_PRICE * result['days']
        result['prettyRentalPrice'] = "$" + result['rentalPrice'];
        result['depositType'] = this.$store.state.userData['deposit'] == "Deposit $500" ?
                                    this.config.DEPOSIT_TYPE_LUMP : this.config.DEPOSIT_TYPE_PERDAY
        let totalDeposit = 0;
        let depositTypeName = "";
        let waiver = 0
        switch(result['depositType']){
          case this.config.DEPOSIT_TYPE_LUMP:
            totalDeposit = this.config.DEPOSIT_FEE_LUMP
            depositTypeName = "deposit"
            result['prettyDebositAmount'] = "$" + totalDeposit
          break;
          case this.config.DEPOSIT_TYPE_PERDAY:
            totalDeposit = this.config.DEPOSIT_FEE_DAILY * result['days']
            waiver = totalDeposit
            depositTypeName = "waiver"
            result['prettyDebositAmount'] = "$" + this.config.DEPOSIT_FEE_DAILY + " per day"
          break;
        }

        result['totalDeposit'] = totalDeposit
        result['depositName'] = depositTypeName

        let subtotalPrice = result['rentalPrice'] + result['transferPrice'] + waiver
        result['tax'] = subtotalPrice * this.config.TAX_PERCENTAGE
        result['totalPrice'] = subtotalPrice
        result['prettyTotalPrice'] = "$" + subtotalPrice

        return result
      }
  },
  methods: {
    sendToServer(payload){
      return new Promise((resolve,reject)=>{
        //console.log(payload);
        axios.post("https://mister-paradise.com/booknow/process.php",Qs.stringify(payload)).then(response => {
        //axios.post("http://localhost/lina/process.php",Qs.stringify(payload)).then(response => {
          if(!response.data.result){
            if(response.data.data){
              reject("error: " + response.data.data)
            }else{
              reject("error: " + response.data)
            }
          }else{
            resolve(response.data.data)
          }
        }).catch(err => {
            reject('Something went wrong:' + err)
        })
      })
    }
  },
  created(){
  }
}
export default GlobalHelper
